import moment from "moment";
import { useRef, useState } from "react";
import { Card, Col, Jumbotron, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import CardActionMedicalColombia from "./CardActionMedicalColombia";
import CardActionMedicalMexico from "./CardActionMedicalMexico";
import CardActionRightMedicalColombia from "./CardActionRightMedicalColombia";
import CardActionRightMedicalMexico from "./CardActionRightMedicalMexico";
import CardDataClientColombia from "./CardDataClientColombia";
import CardDataClientMexico from "./CardDataClientMexico";

function DoctorCitaConcluido({t, messageCita, cita, companyType, handleShowEditData, setShowSuccess, setShowModalServer, setErrorServer, handleShowEditDataMexico, 
    setCita, reload, setReload}){
    const [validDiagnostico, setValidDiagnostico] = useState(false)
    const scrollRef = useRef()

    return(
        <Row>
            <Col xs="12" md="6" className="overflow-y-auto h-scrollbar h-100vh order-2 order-md-1" ref={scrollRef}>
                <Card className="shadow-1 bg-red-light my-3">
                    <Card.Body>
                        <div className="d-flex justify-content-between">
                            <div>
                                <h6 className="mb-0 text-white">{messageCita}</h6>
                            </div>
                            <div>
                                <h6 className="mb-0 text-white">
                                    {
                                        moment(cita.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD MMMM YYYY HH:mm")
                                    }
                                </h6>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
                {
                    companyType==='colombia' ? 
                    <CardDataClientColombia 
                        cita={cita} 
                        setShowSuccess={setShowSuccess} 
                        handleShowEditData={handleShowEditData} 
                        setShowModalServer={setShowModalServer} 
                        setErrorServer={setErrorServer}
                    /> : 
                    <CardDataClientMexico cita={cita} setShowSuccess={setShowSuccess} handleShowEditDataMexico={handleShowEditDataMexico} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer}/>
                }
                {
                    companyType==='colombia' ? 
                    <CardActionMedicalColombia cita={cita} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer} 
                                               validDiagnostico={validDiagnostico} scrollRef={scrollRef} setCita={setCita} reload={reload} setReload={setReload}/> :
                    <CardActionMedicalMexico cita={cita} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer} setShowSuccess={setShowSuccess} setReload={setReload}/>
                }
            </Col>
            <Col xs="12" md="6" className="order-1 order-md-2">
                <Jumbotron className="my-3">
                    <h3 className="text-center">{t('cita_concluido')}</h3>                        
                </Jumbotron>

                <Row className="mb-3">
                    <Col>
                        {
                            companyType==='colombia' ? 
                            <CardActionRightMedicalColombia cita={cita} setValidDiagnostico={setValidDiagnostico}/> :
                            <CardActionRightMedicalMexico cita={cita} />
                        }
                    </Col>
                </Row>
            </Col>
        </Row>
    )

}

export default withTranslation()(DoctorCitaConcluido)